export const allocationConstants = {
    GET_ALLOCATION_REQUEST: 'GET_ALLOCATION_REQUEST',
    GET_ALLOCATION_SUCCESS: 'GET_ALLOCATION_SUCCESS',
    GET_ALLOCATION_FAILURE: 'GET_ALLOCATION_FAILURE',

    CREATE_ALLOCATION_REQUEST: 'CREATE_ALLOCATION_REQUEST',
    CREATE_ALLOCATION_SUCCESS: 'CREATE_ALLOCATION_SUCCESS',
    CREATE_ALLOCATION_FAILURE: 'CREATE_ALLOCATION_FAILURE',

    UPDATE_ALLOCATION_REQUEST: 'UPDATE_ALLOCATION_REQUEST',
    UPDATE_ALLOCATION_SUCCESS: 'UPDATE_ALLOCATION_SUCCESS',
    UPDATE_ALLOCATION_FAILURE: 'UPDATE_ALLOCATION_FAILURE',

    COPY_ALLOCATIONS_REQUEST: 'COPY_ALLOCATIONS_REQUEST',
    COPY_ALLOCATIONS_PROGRESS: 'COPY_ALLOCATIONS_PROGRESS',
    COPY_ALLOCATIONS_SUCCESS: 'COPY_ALLOCATIONS_SUCCESS',

    DELETE_ALLOCATION_REQUEST: 'DELETE_ALLOCATION_REQUEST',
    DELETE_ALLOCATION_SUCCESS: 'DELETE_ALLOCATION_SUCCESS',
    DELETE_ALLOCATION_FAILURE: 'DELETE_ALLOCATION_FAILURE',
};
